import {dynamicWrapper, createRoute} from '@/utils/core';

const routesConfig = (app) => ({
  path: '/property/point',
  title: '数据资产',
  component: dynamicWrapper(app, [], () => import('./class')),
  exact: true
});

export default (app) => createRoute(app, routesConfig);
